import React, { useState, useEffect } from "react";

import { Helmet } from "react-helmet";

import "./chat-page.css";
import { useHistory } from "react-router-dom";
import { firebaseFirestore, updateMessage, getCollection, firebase, firebaseStorage } from "./firebase";

const ChatPage = (props) => {
  const [messageUser, setMessageUser] = useState("");
  const [messages, setMessages] = useState([]);
  const [currentUser, setCurrentUser] = useState("ss878@snu.edu.in");
  const [selectedImage, setSelectedImage] = useState(null);
  const [currentChat, setCurrentChat] = useState("clientEmail:clientName:deliveryEmail:deliveryName");
  const [infoPopUp, setInfoPopUp] = useState(false);
  const [upiDetails, setUpiDetails] = useState({});
  const [deliveryMobile, setDeliveryMobile] = useState("");
  let history = useHistory();

  useEffect(async () => {
    // Wait for the first useEffect hook to finish before continuing
    await new Promise(resolve => {
      if (props.location.state?.orderId === undefined) {
        history.push("/store");
        resolve();
      } else if (props.location.state?.data === undefined && props.location.state?.orderId !== undefined) {
        history.push("/pending", { orderId: props.location.state?.orderId });
        resolve();
      } else {
        setCurrentChat(`${props.location.state?.data.email},${props.location.state?.data.name}:${props.location.state?.data.deliveryEmail},${props.location.state?.data.deliveryName}`);
        resolve();
      }
    });

    // Set up an onSnapshot listener for the Firestore document corresponding to the chat
    let success = firebaseFirestore.onSnapshot(firebaseFirestore.doc(firebase.db, "orders", props.location.state?.orderId), (snapshot) => {
      const order = snapshot.data();
      if (order?.status === 'success') {
        setMessages([]);
        success();
        history.push("/store");
      }
    });
    let unsubscribe = firebaseFirestore.onSnapshot(firebaseFirestore.doc(firebase.db, "chats", currentChat), (snapshot) => {
      const newMessages = snapshot.data();
      if (newMessages?.cancel) {
        setMessages([]);
        unsubscribe();
        history.push("/store");
      }
      setMessages(newMessages?.chats || []);
      if (newMessages?.chats.length > 0) {
        document.querySelector(".chat-page-container3").scrollTo(0, document.querySelector(".chat-page-container3").scrollHeight);
      }
    });

    // Return a cleanup function to unsubscribe from the listener
    return () => {
      unsubscribe();
    };
  }, [props.location.state, history, currentChat]);

  useEffect(() => {
    document.querySelector(".chat-page-container3").scrollTo(0, document.querySelector(".chat-page-container3").scrollHeight);
  }, []);

  useEffect(async () => {
    let user = await firebaseFirestore.getDoc(firebaseFirestore.doc(firebase.db, "users", props.location.state?.data.deliveryEmail));
    setUpiDetails({ qr: user.data()?.qrcode, upi: user.data()?.upiID });
    setDeliveryMobile(`tel:${user.data()?.phoneNumber}`);
  }, [infoPopUp])

  const handleImageChange = async (e) => {
    const file = e.target.files[0];
    const imageRef = firebaseStorage.ref(firebase.storage, file?.name);
    firebaseStorage.uploadBytes(imageRef, file).then(() => {
      firebaseStorage.getDownloadURL(imageRef).then((url) => {
        updateMessage({
          isImage: true,
          user: 'client',
          message: url,
          time: firebaseFirestore.Timestamp.now(),
        }, currentChat);
      })
      setSelectedImage(file);
    });
    // imageRef.put(file).then(() => {
    //   imageRef.getDownloadURL().then((url) => {
    //     updateMessage({
    //       isImage: true,
    //       user: 'client',
    //       message: url,
    //       time: firebaseFirestore.Timestamp.now(),
    //     }, currentChat);
    //   })
    //   setSelectedImage(file);
    // });
  };

  const handleMessageUser = (e) => {
    e?.preventDefault();

    const newMessage = {
      isImage: false,
      user: 'client',
      message: messageUser,
      time: firebaseFirestore.Timestamp.now(),
    };

    let doc = updateMessage(newMessage, currentChat);
    if (doc) {
      setMessageUser("");
    }
  };

  const handleAttachmentClick = (e) => {
    const input = document.createElement("input");
    input.type = "file";
    input.accept = "image/*";
    input.onchange = handleImageChange;
    input.click();
  };

  return (
    <div className="chat-page-container">
      <Helmet>
        <title>chatPage - DeliBuddy</title>
        <meta property="og:title" content="chatPage - DeliBuddy" />
      </Helmet>
      <div className="chat-page-container2">
        <div className="chat-page-header">
          <span className="chat-page-text">Chat</span>
          <div className="chat-page-container04">
            <a href={deliveryMobile}>
              <svg viewBox="0 0 1024 1024" className="chat-page-icon1">
                <path d="M282 460q96 186 282 282l94-94q20-20 44-10 72 24 152 24 18 0 30 12t12 30v150q0 18-12 30t-30 12q-300 0-513-213t-213-513q0-18 12-30t30-12h150q18 0 30 12t12 30q0 80 24 152 8 26-10 44z"></path>
              </svg>
            </a>
            <svg viewBox="0 0 1024 1024" className="chat-page-icon2" onClick={() => {
              setInfoPopUp(true);
            }}>
              <path d="M470 384v-86h84v86h-84zM512 854q140 0 241-101t101-241-101-241-241-101-241 101-101 241 101 241 241 101zM512 86q176 0 301 125t125 301-125 301-301 125-301-125-125-301 125-301 301-125zM470 726v-256h84v256h-84z"></path>
            </svg>
          </div>
        </div>
        <div className="chat-page-container3">
          {
            messages.map((e) => {
              if (e.isImage) {
                return (
                  <img
                    key={e?.time}
                    src={e.message}
                    className={`chat-page-image-${e.user == 'client' ? "right" : "left"
                      }`}
                  />
                )
              }
              return (
                <label
                  key={e?.time}
                  className={`chat-page-text-${e.user == 'client' ? "right" : "left"
                    }`}
                >
                  <p
                    style={{
                      overflowWrap: "anywhere",
                    }}
                  >

                    {e.message}
                  </p>
                </label>
              );
            })}
        </div>
        <div className="chat-page-container4">
          <input
            type="text"
            placeholder="Type your message here..."
            className="chat-page-textinput input"
            value={messageUser}
            onChange={(e) => setMessageUser(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Escape") {
                setMessageUser("");
                e.target.blur();
              }
              if (e.key === "Enter") {
                handleMessageUser();
              }
            }}
          />
          <svg
            viewBox="0 0 1024 1024"
            className="chat-page-icon"
            onClick={() => {
              handleAttachmentClick();
            }}
          >
            <path d="M704 256h64v490q0 98-68 167t-166 69-167-69-69-167v-532q0-70 51-121t121-51 120 51 50 121v448q0 44-31 75t-75 31-76-31-32-75v-406h64v406q0 18 13 30t31 12 30-12 12-30v-448q0-44-31-76t-75-32-76 32-32 76v532q0 70 51 121t121 51 120-51 50-121v-490z"></path>
          </svg>
          <button
            className="chat-page-button button"
            onClick={handleMessageUser}
          >
            Send
          </button>
        </div>
      </div>
      {infoPopUp && (<div className="chat-page-container07">
        <div className="chat-page-container08">
          <div className="chat-page-container09">
            <div className="chat-page-container10">
              <span className="chat-page-text20">Order detail</span>
              <svg viewBox="0 0 1024 1024" className="chat-page-icon6" onClick={() => {
                setInfoPopUp(false);
              }}>
                <path d="M1014.662 822.66c-0.004-0.004-0.008-0.008-0.012-0.010l-310.644-310.65 310.644-310.65c0.004-0.004 0.008-0.006 0.012-0.010 3.344-3.346 5.762-7.254 7.312-11.416 4.246-11.376 1.824-24.682-7.324-33.83l-146.746-146.746c-9.148-9.146-22.45-11.566-33.828-7.32-4.16 1.55-8.070 3.968-11.418 7.31 0 0.004-0.004 0.006-0.008 0.010l-310.648 310.652-310.648-310.65c-0.004-0.004-0.006-0.006-0.010-0.010-3.346-3.342-7.254-5.76-11.414-7.31-11.38-4.248-24.682-1.826-33.83 7.32l-146.748 146.748c-9.148 9.148-11.568 22.452-7.322 33.828 1.552 4.16 3.97 8.072 7.312 11.416 0.004 0.002 0.006 0.006 0.010 0.010l310.65 310.648-310.65 310.652c-0.002 0.004-0.006 0.006-0.008 0.010-3.342 3.346-5.76 7.254-7.314 11.414-4.248 11.376-1.826 24.682 7.322 33.83l146.748 146.746c9.15 9.148 22.452 11.568 33.83 7.322 4.16-1.552 8.070-3.97 11.416-7.312 0.002-0.004 0.006-0.006 0.010-0.010l310.648-310.65 310.648 310.65c0.004 0.002 0.008 0.006 0.012 0.008 3.348 3.344 7.254 5.762 11.414 7.314 11.378 4.246 24.684 1.826 33.828-7.322l146.746-146.748c9.148-9.148 11.57-22.454 7.324-33.83-1.552-4.16-3.97-8.068-7.314-11.414z"></path>
              </svg>
            </div>
            <div className="chat-page-container11">
              <div className="chat-page-container12">
                <span>
                  <span>OTP: {props.location.state?.data.otp}</span>
                  <br></br>
                </span>
                <textarea
                  value={props.location.state?.data.description}
                  disabled={true}
                  className="chat-page-order textarea"
                ></textarea>
                <img
                  src={upiDetails?.qr}
                  alt={upiDetails?.upi}
                  className="chat-page-image"
                />
                <span className="chat-page-text24">
                  <span>{upiDetails?.upi}</span>
                  <br></br>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>)}
    </div>
  );
};

export default ChatPage;
